/* Componente interno al drawer per la creazione della Toc */

import React from 'react';
import tariffaImage from './eurobianco.svg'
import CloseIcon from '@material-ui/icons/Close';
import './TariffaComponent.css'
import { Trans } from 'react-i18next';
import TariffaList from '../TariffaList/TariffaList.js'

import { useTranslation } from 'react-i18next';


export default function TariffaComponent(props) {
  useTranslation();
  //  const {t} = useTranslation();
  const [lunghezza, setLunghezza] = React.useState(280)
  
  const setDiv = (status) => {
    status ? setLunghezza(350) : setLunghezza(280)
    
  }
  
  return (
        <div className={"lateraltDiv"}>
          <div className={"title"}>
            <img src={tariffaImage} alt="Calcolo" className={"tariffaImage"}></img><Trans>CALCOLA TARIFFA AUTOBUS EXTRAURBANI</Trans> <button className={"buttonClose"} onClick={props.callback}><CloseIcon/></button></div>
            <TariffaList callback={setDiv.bind(this)}></TariffaList>            
        </div>

  );
}